import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "gallery" }
const _hoisted_3 = ["src"]

import { appData } from '@/lib/app-data';

export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenshotsGallery',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).screenshots, (shot) => {
        return (_openBlock(), _createElementBlock("div", {
          key: shot.id,
          class: "shot-wrap"
        }, [
          _createElementVNode("img", {
            src: shot.src,
            alt: "",
            class: "shot"
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ])
  ]))
}
}

})